import { createContext, useContext } from "react"

import type { DrilldownSeed } from "./types"

export const DrilldownSeedContext = createContext<DrilldownSeed | null>(null)

export function useDrilldownSeed(): DrilldownSeed | null {
  return useContext(DrilldownSeedContext)
}
